


















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LabelInput extends Vue {
  @Prop()
  private placeholder!: string;

  @Prop()
  private inputtedLabels!: string[];

  @Prop()
  private existingLabels!: string[];

  @Prop({ required: false, default: true })
  private doesAllowNewLabels!: boolean;

  @Prop()
  private noDataText!: string;

  @Prop({ required: false, default: false })
  private hideDetails!: boolean;

  @Prop({ required: false, default: false })
  private isReadOnly!: boolean;

  private existingLabelsValue: string[] = [];
  private inputtedLabelsValue: string[] = [];

  private search: string = '';

  private get result() {
    if (this.search) {
      return `${this.search} ${this.$t(
        'jobScheduler.common.holidayLabel.notFound'
      )}`;
    } else {
      return this.$t('jobScheduler.common.holidayLabel.allSelected');
    }
  }

  public async created(): Promise<void> {
    this.existingLabelsValue = this.existingLabels;
    this.inputtedLabelsValue = this.inputtedLabels;
  }

  @Emit('changedLabels')
  private onChangeLabels(inputtedLabels: string[]): void {}
}
